import { RegisterItem } from '@wearejh/m2-pwa-engine/lib/types';

import { hubspotAddedProductToCart } from './epics/addToCart.epic';
import { hubspotViewProduct } from './epics/viewProduct.epic';
import { hubspotStartCheckout } from './epics/startCheckout';

export function hubspotRegister(): RegisterItem {
    return {
        epics: [hubspotAddedProductToCart, hubspotStartCheckout, hubspotViewProduct],
        reducers: {},
        name: 'hubspot',
    };
}
